/* eslint-disable no-unused-vars */

import React, {Component} from "react";
import {TextField, withStyles} from "@material-ui/core";
import classNames from 'classnames';
import Util from "../../../yeffect/utils";

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class TextInput extends Component {
    state = {
        active:     this.props.active || 1
    }

    onChange = (event) => {
        alert(event)
    }

    render() {
        const { classes, value, width, onChange, fieldLabel, fieldName, fieldValue, errorFields} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <TextField
                        id="standard-basic"
                        label={fieldLabel}
                        InputLabelProps={{ shrink: (!Util.isEmpty(value) || value === false)}}
                        name={fieldName}
                        className={classes.input}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        required={this.props.required}
                        error={!(typeof errorFields[fieldName] === "undefined")}
                        helperText={(typeof errorFields[fieldName] !== "undefined") ? errorFields[fieldName] : this.props.helperText}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(TextInput);


// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/TextInput.js